export const sidebarConstants = {
  _CHANGE: "_CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR"
};
